<script setup>
import { computed } from 'vue';
import { LogOut } from "lucide-vue-next";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@/components/ui/sidebar';

const props = defineProps({
  user: { type: Object, required: true },
  customer: { type: Object, required: false, default: null },
});

import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const environment = document.documentElement.dataset.env || "";
const showEnvUserDebug = ["development", "staging"].includes(environment);

const roleNames = computed(() => (props.user?.role_names || []).join(", "));
const functionNames = computed(() => (props.user?.function_names || []).join(", "));
const customerName = computed(
  () =>
    props.user?.customer_name ||
    props.user?.Kunde?.Kunde ||
    props.user?.kunde?.Kunde ||
    props.customer?.Kunde ||
    "-"
);
</script>

<template>
  <SidebarMenu>
	<SidebarMenuItem v-if="showEnvUserDebug" class="mb-2 px-2 text-xs text-muted-foreground">
		<div class="font-medium text-foreground break-all pb-2">{{ props.user?.firstname + " " + props.user?.lastname || "-" }}</div>
		<div><p class="font-bold">Kunde:</p> {{ customerName }}</div>
		<div><p class="font-bold">Rollen:</p> {{ roleNames || "-" }}</div>
		<div><p class="font-bold">Funktionen:</p> {{ functionNames || "-" }}</div>
	</SidebarMenuItem>
	<SidebarMenuItem>
		<SidebarMenuButton>	
			<LogOut />
			<a href="/logout"> {{ t('view.logout') }}</a>
			
		</SidebarMenuButton>
	</SidebarMenuItem>
  </SidebarMenu>
</template>
